import React from 'react';
import { motion } from 'framer-motion';
import {
  Sparkles,
  BadgeDollarSign,
  HandHeart,
  Scissors,
  Layers,
  Store,
  Truck,
  Crown,
} from 'lucide-react';
import { WHYUS } from '@/constants/testIds';

const items = [
  { slug: 'premium-fabrics', icon: Sparkles, title: 'Premium Quality Fabrics', desc: 'Hand-picked silks, georgettes & velvets sourced with care.' },
  { slug: 'affordable-luxury', icon: BadgeDollarSign, title: 'Affordable Luxury', desc: 'Designer-grade pieces at boutique prices.' },
  { slug: 'styling', icon: HandHeart, title: 'Personal Styling', desc: 'One-on-one consultations with our owner Shally.' },
  { slug: 'tailoring', icon: Scissors, title: 'Tailoring Available', desc: 'In-house alterations for a flawless fit.' },
  { slug: 'collection', icon: Layers, title: 'Large Collection', desc: '14+ categories across every age & occasion.' },
  { slug: 'pickup', icon: Store, title: 'Local Pickup', desc: 'Walk-in In-Home Boutique Showroom in Morrisville, NC.' },
  { slug: 'delivery', icon: Truck, title: 'US-Wide Shipping', desc: 'Local Triangle delivery + shipping across the United States.' },
  { slug: 'women-owned', icon: Crown, title: 'Women-Owned', desc: 'Proudly women & Asian-owned · LGBTQ friendly.' },
];

export const WhyChooseUs = () => {
  return (
    <section id="why-us" data-testid={WHYUS.root} className="py-24 lg:py-32 bg-ivory">
      <div className="container-luxe">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="overline">Why Trendy Closet</span>
          <h2 className="font-display text-4xl lg:text-5xl text-charcoal mt-3 leading-tight">
            A boutique experience, <em className="text-maroon not-italic font-medium">tailored for you</em>.
          </h2>
          <div className="mt-5 mx-auto h-px w-16 bg-gold" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brandborder/60 border border-brandborder/60">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.slug}
                data-testid={WHYUS.card(it.slug)}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="bg-ivory p-8 lg:p-10 group hover:bg-surface transition-colors duration-500"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-gold/60 text-maroon group-hover:bg-maroon group-hover:text-ivory transition-all duration-500">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-display text-xl text-charcoal mt-6 tracking-tight">{it.title}</h3>
                <p className="text-sm text-charcoal/65 mt-2 leading-relaxed">{it.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
